import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { useHeroHeader } from '../../app/HeroHeader';
import { FeaturedAttractions } from './FeaturedAttractions';
import { HikingTrailsPromo } from './HikingTrailsPromo';
import { Highlights } from './Highlights';
import { HomeHero } from './HomeHero';
import { InfiniteBanner } from './InfiniteBanner';
import { MobileAppSection } from './MobileAppSection';
import { PartnerStrip } from './PartnerStrip';

// Maps lazy-load (§15) — Leaflet + tiles are heavy and below the fold.
const MapExplore = lazy(() =>
  import('../attractions/MapExplore').then((m) => ({ default: m.MapExplore })),
);

/**
 * Home (`/`) — spec §7.1, sections in document order:
 *   hero → partner strip → MapExplore (all regions) → "Your Adventure Starts Here"
 *   (featured attractions) → hiking-trails promo → "Infinite Adventure Awaits" banner →
 *   Highlights (latest posts) → mobile-app block → footer.
 */
export function HomePage() {
  const { t } = useTranslation();
  // Full-bleed hero → header sits transparently over it until scroll (§25.2).
  useHeroHeader();

  return (
    <>
      <HomeHero />

      <PartnerStrip />

      {/* MapExplore — Home shows ALL regions (§7.1, §25.4). */}
      <Suspense
        fallback={
          <div className="mx-4 my-8 flex h-96 items-center justify-center rounded-3xl border border-line bg-panel text-content-muted sm:mx-6 lg:mx-8">
            {t('common.loading')}
          </div>
        }
      >
        <MapExplore heading={t('map.homeHeading')} intro={t('map.homeIntro')} />
      </Suspense>

      <FeaturedAttractions />

      <HikingTrailsPromo />

      <InfiniteBanner />

      <Highlights />

      <MobileAppSection />
    </>
  );
}
